import { recommendationApi } from './endpoints';
import { fetchWrapped } from './';

const getUserRecommendation = async ({ userJWT, userId }) =>
  await fetchWrapped(`${recommendationApi}/personalized?userId=${userId}`, {
    method: 'GET',
    headers: { Authorization: `Bearer ${userJWT}` },
  });

const getMostViewRecommendation = async ({ userId }) =>
  await fetchWrapped(`${recommendationApi}/mostViewedItems?userId=${userId}`);

const getRelatedRecommendation = async ({ userId }) =>
  await fetchWrapped(`${recommendationApi}/relatedViews?userId=${userId}`);

export default {
  getUserRecommendation,
  getMostViewRecommendation,
  getRelatedRecommendation,
};
